import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  return (
    <motion.nav
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 w-full bg-white shadow-md z-50"
    >
      <div className="container mx-auto flex justify-between items-center p-4">
        <div className="text-2xl font-bold text-gray-800">Captured in the Bay</div>
        <ul className="flex space-x-6">
          <li><Link to="/" className="text-gray-700 hover:text-gray-900">Home</Link></li>
          <li><Link to="/gallery" className="text-gray-700 hover:text-gray-900">Gallery</Link></li>
          <li><Link to="/about" className="text-gray-700 hover:text-gray-900">About</Link></li>
          <li><Link to="/contact" className="text-gray-700 hover:text-gray-900">Contact</Link></li>
        </ul>
      </div>
    </motion.nav>
  );
};

export default Navbar;